import SingleLandingPageGetData from "./SingleLandingPageGetData";
import SingleLandingPageInfo from "./BestBettingSitesInfo/SingleLandingPageInfo";
import LandingPageMetrics from "./LandingPageMetrics/LandingPageMetrics";
import FloatingActionItems from "../../../../../pages/FloatingItems/FloatingActionItems";
import { useSearchParams } from "react-router-dom";

const BestBettingSites = () => {
  const [searchParams] = useSearchParams();
  const selectedSite = searchParams.get("selectedSite") as any;
  return (
    <>
      <SingleLandingPageGetData />
      <SingleLandingPageInfo />
      <LandingPageMetrics />
      <div data-tracker="493">
        <FloatingActionItems
          selectedSiteFloatingAction={selectedSite}
          selectedDimensionsFloatingAction=""
          trackIdFloatingAction="473"
        />
      </div>
    </>
  );
};

export default BestBettingSites;
